import { useContext, useEffect, useState } from 'react'
import { getForm } from '../../services/api/cms'
import { FormsProps, WagtailBlockProps } from '../../services/api/types'
import { SiteContext } from '../../services/context/SiteContext'
import { Col, Container, Row, Section } from '../../styles/grid.styles'
import * as S from './Brochure.styled'
import RegisterYourInterestModal from './RegisterYourInterestModal'

export interface BrochureProps extends WagtailBlockProps {
  value: {
    title: string
    image: string
    content: string
    button_text: string
    form: FormsProps
    require_auth_everytime?: boolean
    button_link: {
      link_target?: string
      external_link?: string
      page_link?: string
      document_link?: string
      anchor_link?: string
    }
  }
}
const getFormContent = async (ctx: any = null, params: any) => {
  const formRes = await getForm(ctx, params)
  if (formRes && formRes.results && formRes.results.length > 0) {
    const formData = formRes.results[0]
    delete formData.title
    return {
      ...formData
    }
  }

  return {}
}
const Brochure = (props: BrochureProps) => {
  const appContext = useContext(SiteContext)
  const { setFormBrochure } = useContext(SiteContext)
  const {
    title,
    image,
    content,
    button_text,
    button_link,
    form,
    require_auth_everytime
  } = props.value
  const link = {
    url:
      button_link.page_link ||
      button_link.document_link ||
      button_link.external_link ||
      button_link.anchor_link ||
      undefined,
    target: button_link.link_target
  }
  const [formFields, setFormFields] = useState<any>()

  useEffect(() => {
    getFormFields()
  }, [])

  const getFormFields = async () => {
    const form_fields = await getFormContent(null, {
      slug: form && form.slug ? form.slug : ''
    })
    form_fields.linkUrl =
      button_link.external_link ||
      button_link.document_link ||
      button_link.page_link ||
      button_link.anchor_link ||
      undefined
    form_fields.linkTarget = button_link.link_target
    form_fields.title = form.title
    form_fields.preamble = form.preamble
    setFormFields(form_fields)
    setFormBrochure &&
      setFormBrochure({
        ...form_fields,
        requireAuthEverytime: require_auth_everytime
      })
  }

  return (
    <Section>
      <Container size='lg'>
        <Row itemsCenter gutter={10}>
          {image && (
            <Col md={6}>
              <S.Image src={image} alt={title} />
            </Col>
          )}
          <Col md={6}>
            <S.Info>
              {title && <S.Title>{title}</S.Title>}
              <S.Content dangerouslySetInnerHTML={{ __html: content }} />
              {appContext.siteInfor?.isDownloadable &&
                !require_auth_everytime ? (
                <S.Link href={link.url} download={button_link.document_link && !button_link.external_link}>
                  {button_text}
                </S.Link>
              ) : (
                <RegisterYourInterestModal
                  button={<S.Button>{button_text}</S.Button>}
                  downloadFileOnSuccess={true}
                  form={formFields}
                  fileUrl={link.url}
                  isDocumentLink={button_link.document_link && !button_link.external_link ? true : false}
                />
              )}
            </S.Info>
          </Col>
        </Row>
      </Container>
    </Section>
  )
}
export default Brochure
